import React, { useState, useEffect } from "react";

import { isFunction } from "../../Libs/CustomMethods/customMethods";

import { AvField } from "availity-reactstrap-validation";

const ExtraFields = ({ t, ...props }) => {
  const [extraItemValues, setExtraItemValues] = useState({});

  useEffect(() => {
    isFunction(props.onChange) && props.onChange(extraItemValues);
  }, [extraItemValues]);

  useEffect(() => {
    props.value && setExtraItemValues(props.value);
  }, [props.value]);

  return props.fields.map((extraItem, idx) => (
    <AvField
      key={idx}
      label={extraItem?.required ? `${extraItem?.title} *` : extraItem?.title}
      name={extraItem?.name}
      maxLength={extraItem?.max_length}
      placeholder={extraItem?.place_holder}
      required={extraItem?.required}
      title={extraItem?.title}
      onChange={(e) =>
        setExtraItemValues({
          ...extraItemValues,
          [extraItem.name]: e.target.value,
        })
      }
      value={props.value?.[extraItem.name] ?? ""}
    />
  ));
};

export default ExtraFields;
